import { useRef, useEffect, useState } from "react";
import { IconButton } from "../atoms/buttons";
import { Spinner } from "../atoms/spinner";
import { HorizontalLayout, VerticalLayout } from "../components/layout";

export default function CourseAiDescription({courseData, description, collapsible = false, expanded}) {
  const activeDescription = description || {
    description: courseData.description,
    extra_description: courseData.extra_description,
    layout: courseData.layout || "paragraphs",
  };

  return (
    <VerticalLayout style={{ position: "relative", marginTop: "0.5rem" }}>
      {collapsible ? (
        <CollapsibleText maxLength={250} expanded={expanded} text={activeDescription.description} extra={activeDescription.extra_description}/>
      ) : (
        <p>{activeDescription.description}</p>
      )}
    </VerticalLayout>
  );
}
function CollapsibleText({ text, maxLength = 100, extra, expanded }) {
  const contentRef = useRef(null);
  if (!text) return null;
  const isLong = text.length > maxLength;
  const fullText = (
    <>
      {text}
      {extra && (
        <>
          <br />
          <br />
          {extra}
        </>
      )}
    </>
  );

  const displayText = text && isLong && !expanded ? text.slice(0, maxLength) + "..." : fullText;

  return (
    <VerticalLayout style={{ width: "auto" }} ref={contentRef} className={`collapsible ${expanded ? "expanded" : "collapsed"}`}>
      <p className="bottom-text-subtitle">{displayText}</p>
    </VerticalLayout>
  );
}
